// extracted by mini-css-extract-plugin
export default {"ticketRemaining":"ExpositionTicket_ticketRemaining__7WWD0"};